/* eslint-disable react/prop-types */
// WindMachine.jsx
import React from 'react'

const WindMachineDefault = ({ style }) => <WindMachine style={style} />

export default WindMachineDefault

export const WindMachine = ({ height, width, style }) => {
  const svgStyle = { fill: '#284047', ...style }
  return (
    <svg
      style={svgStyle}
      viewBox='0 0 75 75'
    >
      <description>wind machine icon</description>
      <title>wind machine</title>
      <g
        style={{
          transform: 'translate(7px, 7px) scale(0.36)',
        }}
      >
        <path d='M117.7,34.3c1.1,0.7,1.7,1.9,2.4,3.2c2.4-1.1,5.1-3.4,8.4-6.9c7-8.6,17.1-23.4,18.1-28.6
                  c-0.9-0.7-1.4-1.1-2.7-1.9c-5.1,2.2-17.5,14.8-24.3,23.3c-3.2,3.9-4.7,7.1-5.4,9.5C115.5,33,
                  116.4,33.6,117.7,34.3z'
        />
        <path d='M95.2,51.2C88.8,58.9,79,71.5,76.8,77.7c1.3,1,3.2,2.6,4.4,3.3C87,77.6,97.6,66.1,104,58.6
                  c3-3.7,4.7-6.9,5.4-9.5c-2.6-0.6-4.7-2.4-5.8-4.9C101.2,45,98.4,47.2,95.2,51.2z'
        />
        <path d='M116.5,48.9c0,0-3.4,0.4-4.2,0.4c-1.3,0-2.6-0.2-3.7-0.4l-7.1,108.2H85v-35.9c0-1.7-2.1-3.2-4.5-3.2h-59
                  c-2.4,0-4.5,1.5-4.5,3.2v39.7c0,1.7,2.1,3.2,4.5,3.2h43.4h15.9h20.4c0,0,3.4,0,8.7,0c0.8,0,1.9,0,2.9,0c6.6,
                  0,11.6,0,11.6,0 L117,55.1C116.8,51.9,116.5,49.7,116.5,48.9z'
        />
        <circle cx='112.3' cy='40.9' r='5.2' />
        <path d='M101,24l-47.7-1.1c0,0,0,0-0.2,0c-1.1,0-2.1,0.9-2.1,2.1S52,27,53.1,27l47.7-1.5c0.4,0,0.7-0.4,0.7-0.7
                  C102,24.4,101.4,24,101,24z'
        />
        <path d='M109.1,16l-47.7-1.1c0,0,0,0-0.2,0c-1.1,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1l47.7-1.1c0.4,0,0.7-0.4,0.7-0.7
                  C109.8,16.4,109.5,16,109.1,16z'
        />
        <path d='M117,8.1L69.2,6.8c-1.1,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1L117,9.8c0.4,0,0.7-0.4,0.7-0.7
                  C117.7,8.7,117.3,8.1,117,8.1z'
        />
      </g>
    </svg>
  )
}
